import React, { useState } from "react"
import searchIcon from "../../assets/images/icons/search.svg"
import mobileSearchIcon from "../../assets/images/icons/mobileSearch.png"
import { Input } from "reactstrap"
import InvestorSearchModal from "./investorSearchModal"

const GlobalSearch = () => {
  const [open, setOpen] = useState(false)

  const handleInputFocus = () => {
    setOpen(true)
  }

  return (
    <>
      <div className="top-search-bar">
        {window.innerWidth <= 998 ? (
          <div onClick={handleInputFocus}>
            <img src={mobileSearchIcon} alt="menuBurger" />
          </div>
        ) : (
          <>
            <Input
              type="text"
              className="form-control"
              placeholder="Search"
              readOnly
              onClick={handleInputFocus}
            />
            <div className="search">
              <img src={searchIcon} alt="menuBurger" />
            </div>
          </>
        )}
      </div>
      {open && <InvestorSearchModal open={open} setOpen={setOpen} />}
    </>
  )
}

export default GlobalSearch
